import { CSSObject } from '@emotion/react'
import { fontSizes, fontWeights } from '@opallabs/pulsar'
import { sharedColors, sharedStyles } from '../../sharedStyles'

const footerWrapper: CSSObject = {
  backgroundColor: 'white',
  borderRadius: '0  0 3px 3px',
  width: '375px',
}

const accountMeasurer: CSSObject = {
  ...(sharedStyles.accountMeasurer as CSSObject),
  insetInlineStart: 15,
}

const responseList: CSSObject = {
  ...sharedStyles.responseList,
  marginBlockEnd: 5,
  marginInlineEnd: 12,
  marginInlineStart: 16,
  paddingTop: 20,
}

type ResponseItemProps = {
  bookmark?: boolean
}

const responseItem = ({ bookmark = false }: ResponseItemProps): CSSObject =>
  sharedStyles.responseItem({ bookmark })

const contentWrapper: CSSObject = {
  position: 'relative',
}

const getInput = (isHeadline?: boolean): CSSObject => ({
  marginBlockEnd: isHeadline ? 0 : 5,
  marginBlockStart: 0,
  marginInlineEnd: 10,
  marginInlineStart: 10,
})

const postedAt: CSSObject = {
  ...(sharedStyles.postedAt as CSSObject),
  fontSize: '12px',
  fontWeight: fontWeights.normal,
  marginBlockStart: 0,
  marginInlineEnd: 16,
  marginInlineStart: 16,
  paddingBottom: 12,
  textTransform: 'initial',
}

const effectStyles: CSSObject = {
  fontWeight: fontWeights.bolder,
}

const effectSeparatorStyles: CSSObject = {
  padding: '0 4px',
}

const ctaWrapper: CSSObject = {
  alignItems: 'center',
  borderBottom: `1px solid ${sharedColors.lightGreyBorder}`,
  display: 'flex',
  fontSize: fontSizes.medium,
  fontWeight: fontWeights.medium,
  justifyContent: 'space-between',
  margin: '0 0 0 15px',
  padding: '12px 0 11px 0',
  width: '345px',
}

export const styles = {
  accountMeasurer,
  contentWrapper,
  ctaWrapper,
  effectSeparatorStyles,
  effectStyles,
  footerWrapper,
  getInput,
  postedAt,
  responseItem,
  responseList,
}
